/*
 * TEMPORARY — demo only.
 *
 * This route renders the ticlick-pricing reference widget verbatim (its own
 * plans, prices, add-ons and copy) so it matches preview/preview.html. The
 * CRM-data-driven configurator built earlier is preserved alongside it in
 * pricing-engine/ and this file's git history; reverting this file and
 * deleting demo/ restores it.
 */

import TicklickPricingWidget from './demo/ticlick-pricing-widget';
import PricingPageWrapper from '@src/features/settings/pages/billing/pricing/components/pricing-page-wrapper';

const PlanAndSubDetails = () => {
  return (
    <PricingPageWrapper hideChrome>
      <TicklickPricingWidget />
    </PricingPageWrapper>
  );
};

export default PlanAndSubDetails;
